import Vue from 'vue';
import mixin from "../../../mixins/mixin";
import paymentsService from './../../../services/payment';


export default {
  data () {
    return {
      loading: true,
      messages: ''
    }
  },

  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading : require('components/loading/loading.vue')
  },

  mixins:[mixin],

  async mounted() {
    let vm = this;
    vm.loading = true;
    await paymentsService.messages(vm);
  },

  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/app/pages/payments/messages/messages.js